import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import axios from './request/http';
import api from './request/api';

import {
  Button,
  Container,
  Header,
  Main,
  Footer,
  Image,
  Menu,
  Submenu,
  MenuItem,
  Carousel,
  CarouselItem,
  Dialog,
  Form,
  FormItem,
  Input,
  Message,
} from 'element-ui';
Vue.config.productionTip = false;
Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.use(Button);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Image);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.prototype.$message = Message;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
